import { Tabs, TabsProps } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../../Layout';
import BreadcrumbBlock from '../../../components/BreadcrumbBlock/BreadcrumbBlock';
import Integration from './Components/Integration';
import Share from './Components/Share';
import './styles.scss'


export interface DataTypeGeneralConfiguration {
  key: React.Key;
  category: string;
  supplier: string;
  APIKey: string;
  SecretKey: string;
  connectionDate: string
  ZaloAppID: string;
  status: number
  zaloAppSecretKey: string,
  zaloOASecretKey: string,
  zaloRefreshToken: string,
  authType: number
  encryptionType: number,
  smtpHost: string,
  smtpPort: string

}

export const GeneralConfigurationV2: React.FC = () => {
  return (
    <div className="notification-templates-management">
      <Layout>
        <BreadcrumbBlock
          items={[
            { title: <Link to="/">THACO AUTO CRM</Link>, },
            { title: 'Quản trị phần mềm', },
            { title: 'Cấu hình hệ thống', },
          ]}
          title='Cấu hình hệ thống'
        />
        <Tabs
          className='custom-page-css flex flex-1'
          defaultActiveKey="1"
          items={
            [
              {
                key: '1',
                label: <span className='custom-page-css text-base font-regular'>Tích hợp</span>,
                children: <Integration />,
              },
              {
                key: '2',
                label: <span className='custom-page-css text-base font-regular'>Chung </span>,
                children: <Share />,
              },
            ]
          }
        />
      </Layout>
    </div>

  );
}

GeneralConfigurationV2;
